import { render, staticRenderFns } from "./TabModeratorAccountTuition.vue?vue&type=template&id=3ad64c78&"
import script from "./TabModeratorAccountTuition.vue?vue&type=script&lang=js&"
export * from "./TabModeratorAccountTuition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports